import before from '@mailobj-browser/front/js/tree/before.js'
import { render } from '#utilities/js/template/template.js'
import { handle } from './wrapper.js'

const { parseInt } = Number

const handler = async (button, template, buttons, set, nb) => {
  const content = await render(template)
  const value = parseInt(nb.value, 10) + 1
  nb.value = `${value}`
  set.value = 1

  before(buttons, content)
}

export default button => {
  handle(button, handler)
}